import store from '@/store'
export default {
	getMenuList() {
		let permission = store.getters.getMenuPermission;
		let menuList = [];
		let subclassV = [];
		let subclassV2 = [];
		if (permission.includes('CD_100')) {
			menuList.push({
				menu: 'CD_100',
				menuName: '地图显示',
			});
		}
		if (permission.includes('CD_200')) {
			subclassV = [];
			if (permission.includes('CD_210')) {
				subclassV.push({
					menu: 'CD_210',
					menuName: '导出',
				});
			}
			menuList.push({
				menu: 'CD_200',
				menuName: '报警管理',
				subclass: subclassV,
			});
		}
		if (permission.includes('CD_300')) {
			subclassV = [];
			if (permission.includes('CD_310')) {
				subclassV.push({
					menu: 'CD_310',
					menuName: '导出',
				});
			}
			menuList.push({
				menu: 'CD_300',
				menuName: '维护管理',
				subclass: subclassV,
			});
		}
		if (permission.includes('CD_400')) {
			subclassV = [];
			if (permission.includes('CD_410')) {
				subclassV.push({
					menu: 'CD_410',
					menuName: '导出',
				});
			}
			if (permission.includes('CD_420')) {
				subclassV.push({
					menu: 'CD_420',
					menuName: '续签',
				});
			}
			if (permission.includes('CD_430')) {
				subclassV.push({
					menu: 'CD_430',
					menuName: '导出',
				});
			}
			if (permission.includes('CD_440')) {
				subclassV.push({
					menu: 'CD_440',
					menuName: '作废',
				});
			}
			menuList.push({
				menu: 'CD_400',
				menuName: '合同管理',
				subclass: subclassV,
			});
		}
		if (permission.includes('CD_500')) {
			subclassV = [];
			if (permission.includes('CD_510')) {
				subclassV2 = [];
				if (permission.includes('CD_511')) {
					subclassV2.push({
						menu: 'CD_511',
						menuName: '导出',
					});
				}
				subclassV.push({
					menu: 'CD_510',
					menuName: '工作量统计',
					subclass: subclassV2,
				});
			}
			if (permission.includes('CD_520')) {
				subclassV2 = [];
				if (permission.includes('CD_521')) {
					subclassV2.push({
						menu: 'CD_521',
						menuName: '导出',
					});
				}
				subclassV.push({
					menu: 'CD_520',
					menuName: '处理时间统计',
					subclass: subclassV2,
				});
			}
			if (permission.includes('CD_530')) {
				subclassV2 = [];
				if (permission.includes('CD_531')) {
					subclassV2.push({
						menu: 'CD_531',
						menuName: '导出',
					});
				}
				subclassV.push({
					menu: 'CD_530',
					menuName: '报警时间分布统计',
					subclass: subclassV2,
				});
			}
			if (permission.includes('CD_540')) {
				subclassV.push({
					menu: 'CD_540',
					menuName: '报警频度分布统计',
				});
			}
			menuList.push({
				menu: 'CD_500',
				menuName: '数据统计',
				subclass: subclassV,
			});
		}
		if (permission.includes('CD_600')) {
			subclassV = [];
			if (permission.includes('CD_610')) {
				subclassV2 = [];
				if (permission.includes('CD_611')) {
					subclassV2.push({
						menu: 'CD_611',
						menuName: '人员新增',
					});
				}
				if (permission.includes('CD_612')) {
					subclassV2.push({
						menu: 'CD_612',
						menuName: '人员编辑',
					});
				}
				if (permission.includes('CD_613')) {
					subclassV2.push({
						menu: 'CD_613',
						menuName: '人员删除',
					});
				}
				subclassV.push({
					menu: 'CD_610',
					menuName: '人员管理',
					subclass: subclassV2,
				});
			}
			if (permission.includes('CD_620')) {
				subclassV2 = [];
				if (permission.includes('CD_621')) {
					subclassV2.push({
						menu: 'CD_621',
						menuName: '角色新增',
					});
				}
				if (permission.includes('CD_622')) {
					subclassV2.push({
						menu: 'CD_622',
						menuName: '角色编辑',
					});
				}
				if (permission.includes('CD_623')) {
					subclassV2.push({
						menu: 'CD_623',
						menuName: '角色删除',
					});
				}
				subclassV.push({
					menu: 'CD_620',
					menuName: '角色管理',
					subclass: subclassV2,
				});
			}
			if (permission.includes('CD_630')) {
				subclassV2 = [];
				if (permission.includes('CD_631')) {
					subclassV2.push({
						menu: 'CD_631',
						menuName: '区域新增',
					});
				}
				if (permission.includes('CD_632')) {
					subclassV2.push({
						menu: 'CD_632',
						menuName: '区域编辑',
					});
				}
				if (permission.includes('CD_633')) {
					subclassV2.push({
						menu: 'CD_633',
						menuName: '区域删除',
					});
				}
				subclassV.push({
					menu: 'CD_630',
					menuName: '区域管理',
					subclass: subclassV2,
				});
			}
			if (permission.includes('CD_640')) {
				subclassV2 = [];
				if (permission.includes('CD_641')) {
					subclassV2.push({
						menu: 'CD_641',
						menuName: '时间新增',
					});
				}
				if (permission.includes('CD_642')) {
					subclassV2.push({
						menu: 'CD_642',
						menuName: '时间编辑',
					});
				}
				if (permission.includes('CD_643')) {
					subclassV2.push({
						menu: 'CD_643',
						menuName: '时间删除',
					});
				}
				subclassV.push({
					menu: 'CD_640',
					menuName: '时间管理',
					subclass: subclassV2,
				});
			}
			if (permission.includes('CD_650')) {
				subclassV2 = [];
				if (permission.includes('CD_651')) {
					subclassV2.push({
						menu: 'CD_651',
						menuName: '客户新增',
					});
				}
				if (permission.includes('CD_652')) {
					subclassV2.push({
						menu: 'CD_652',
						menuName: '客户编辑',
					});
				}
				if (permission.includes('CD_653')) {
					subclassV2.push({
						menu: 'CD_653',
						menuName: '客户删除',
					});
				}
				subclassV.push({
					menu: 'CD_650',
					menuName: '客户管理',
					subclass: subclassV2,
				});
			}
			if (permission.includes('CD_660')) {
				subclassV2 = [];
				if (permission.includes('CD_661')) {
					subclassV2.push({
						menu: 'CD_661',
						menuName: '设备新增',
					});
				}
				if (permission.includes('CD_662')) {
					subclassV2.push({
						menu: 'CD_662',
						menuName: '设备编辑',
					});
				}
				if (permission.includes('CD_663')) {
					subclassV2.push({
						menu: 'CD_663',
						menuName: '设备删除',
					});
				}
				subclassV.push({
					menu: 'CD_660',
					menuName: '设备管理',
					subclass: subclassV2,
				});
			}
			if (permission.includes('CD_670')) {
				subclassV2 = [];
				if (permission.includes('CD_671')) {
					subclassV2.push({
						menu: 'CD_671',
						menuName: '字典新增',
					});
				}
				if (permission.includes('CD_672')) {
					subclassV2.push({
						menu: 'CD_672',
						menuName: '字典编辑',
					});
				}
				if (permission.includes('CD_673')) {
					subclassV2.push({
						menu: 'CD_673',
						menuName: '字典删除',
					});
				}
				subclassV.push({
					menu: 'CD_670',
					menuName: '字典管理',
					subclass: subclassV2,
				});
			}
			menuList.push({
				menu: 'CD_600',
				menuName: '系统管理',
				subclass: subclassV,
			});
		}
		return menuList;
	},
}



// WEBPACK FOOTER //
// ./src/assets/js/system/menu.js